@if (quotes!.length > 0) {
  <table-pro [configs]="tableConfig">
    <div top-action-2>
      <button type="button" class="btn btn-secondary btn-sm w-100 btn-export" (click)="exportQuotes()">
        <span class="material-symbols-outlined d-flex m-r-4"> download </span>
        {{ 'exportEntries.exportToExcel' | cxTranslate }}
      </button>
    </div>
    <table class="table-responsive table-md">
      <!-- Then the user will see the following data: Quote#, Quote Name, Final Customer, Location, Status, Approval Date, and Expiration Date  -->
      <thead>
        <tr>
          <th>{{ 'quotes.history.tableHeader.quoteNumber' | cxTranslate }}</th>
          <th>{{ 'quotes.history.tableHeader.quoteName' | cxTranslate }}</th>
          <th>{{ 'quotes.history.tableHeader.endCustomer' | cxTranslate }}</th>
          <th>{{ 'quotes.history.tableHeader.location' | cxTranslate }}</th>
          <th>{{ 'quotes.history.tableHeader.status' | cxTranslate }}</th>
          <th>{{ 'quotes.history.tableHeader.approvalDate' | cxTranslate }}</th>
          <th>{{ 'quotes.history.tableHeader.expirationDate' | cxTranslate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (quote of quotes; track quote) {
          <tr>
            <td [attr.data-value]="quote.quoteNumber">
              <span class="responsive-title"> {{ 'quotes.history.tableHeader.quoteNumber' | cxTranslate }}: </span>
              {{ quote.quoteNumber }}
            </td>
            <td>
              <span class="responsive-title"> {{ 'quotes.history.tableHeader.quoteName' | cxTranslate }}: </span>
              <button (click)="navigate(quote.uid)" class="btn-link text-underline">
                {{ quote.quoteName }}
              </button>
            </td>
            <td>
              <span class="responsive-title"> {{ 'quotes.history.tableHeader.endCustomer' | cxTranslate }}: </span>
              {{ quote.endCustomer }}
            </td>
            <td>
              <span class="responsive-title"> {{ 'quotes.history.tableHeader.location' | cxTranslate }}: </span>
              {{ quote.location }}
            </td>
            <td>
              <span class="responsive-title"> {{ 'quotes.history.tableHeader.status' | cxTranslate }}: </span>
              {{ quote.quoteStatus }}
            </td>
            <td [attr.data-value]="quote.effectiveDate">
              <span class="responsive-title"> {{ 'quotes.history.tableHeader.approvalDate' | cxTranslate }}: </span>
              {{ quote.effectiveDate }}
            </td>
            <td [attr.data-value]="quote.expirationDate">
              <span class="responsive-title"> {{ 'quotes.history.tableHeader.expirationDate' | cxTranslate }}: </span>
              {{ quote.expirationDate }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </table-pro>
} @else {
  <p class="m-t-12 h5">{{ 'quotes.history.noQutoeFound' | cxTranslate }}</p>
}

